export function openManagementPortal(managementPortalUrl: string) {
  window.open(managementPortalUrl, "managementPortal");
}
